// https://material-ui.com/customization/spacing/

/**
 * according to https://www.figma.com/file/ckofsw1jymuzNSUBJh4FkM/Spacing-Alignements-with-Material-UI?node-id=0%3A1
 * available options are [0, 4, 8, 16, 24, 32, 64, 80, 96, 128]
 */
const spacingArray = [0, 4, 8, 16, 24, 32, 64, 80, 96, 128];

const spacing = (factor: number): number => spacingArray[factor];

export default spacing;
